import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getIsLoggedIn } from '../../publicSession';
import { restrictLoggedOut } from '../../redux/loggedout';
import noop from '../noop';
/** returns whether current user is logged in,
 *  a dispatched action that sends the user to the sisu login pages,
 *  and a function that will call a callback if logged in, send to login if not */
export function useRestrictToLoggedIn() {
    var isLoggedIn = useSelector(getIsLoggedIn);
    var dispatch = useDispatch();
    var sendUserToJoinPage = useCallback(function (restrictedActionName) {
        dispatch(restrictLoggedOut({ restrictedActionName: restrictedActionName }));
    }, [dispatch]);
    var restrictToLoggedIn = useCallback(function (restrictedActionName, callback) {
        if (callback === void 0) { callback = noop; }
        return function (a) {
            return !isLoggedIn
                ? sendUserToJoinPage(restrictedActionName)
                : callback();
        };
    }, [isLoggedIn, sendUserToJoinPage]);
    return { isLoggedIn: isLoggedIn, sendUserToJoinPage: sendUserToJoinPage, restrictToLoggedIn: restrictToLoggedIn };
}
//# sourceMappingURL=useRestrictToLoggedIn.js.map